import React from 'react';
import NoClaims from '../assets/images/No_Claims_Icon.svg';

export default () => {
  return <img src={NoClaims} alt="" />;
};
